var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplearrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.4241L6.67943 17.8519C6.67943 17.9757 6.8302 18.044 6.93202 17.9683L15.7591 11.4646C15.8341 11.4095 15.8948 11.3391 15.9365 11.2586C15.9783 11.1781 16 11.0896 16 11C16 10.9104 15.9783 10.8219 15.9365 10.7414C15.8948 10.6609 15.8341 10.5905 15.7591 10.5354L6.93202 4.0317C6.82824 3.95597 6.67943 4.02431 6.67943 4.14807L6 5.57594C6 5.66645 6.04503 5.75327 6.11944 5.80868L13.1686 10.9991L6.11944 16.1914C6.04504 16.2468 6 16.3336 6 16.4241Z",
    fill: "#FE8016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplearrow);
export default __webpack_public_path__ + "static/media/simplearrow.72846fd97abc7886c9d503abfb9256e6.svg";
export { ForwardRef as ReactComponent };